import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button } from '@gsa/afp-component-library';

const SolicitationActionButton = ({ action, label, solicitationId }) => {
  const navigate = useNavigate();
  let subpath;
  switch (action) {
    case 'renew':
      subpath = `renew/${solicitationId}`;
      break;
    case 'reopen':
    case 'midcycle':
      subpath = `edit/${solicitationId}/reopen-period`;
      break;
    default: // edit
      subpath = `edit/${solicitationId}`;
  }
  return (
    <Button
      label={label}
      variant="primary"
      data-testid={`solicitation-${action}-btn`}
      onClick={() => {
        navigate(`/catalog/solicitations/${subpath}`);
      }}
    />
  );
};

SolicitationActionButton.propTypes = {
  action: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  solicitationId: PropTypes.string.isRequired,
};

export default SolicitationActionButton;
